<div class="background">
    <nav class="navbar navbar-light first-nav">
        <div></div>
        <p routerLink='/' class="window-logo">{{constants.WINDOW_SWAP_TXT}}</p>
        <img (click)="OnClickClose()" class="close-button" src="{{constants.LOGIN_CLOSE_BUTTON}}" />
    </nav>
    <section class="section-1 container">
        <div class="row">
            <div class="col-12 col-md-4 header-content">
                <h3 class="header-heading">
                    {{constants.OPEN_A_WORLD_TXT}} <br>{{constants.CLAIMING_TXT}}<br>{{constants.HELPING_FEATURE_TXT}}
                </h3>
                <h6 class="header-sub-heading" *ngIf="amount === 50">
                    {{constants.GET_ALL_ACCESS_TXT_PRICING}} <br><span
                        class="header-sub-heading-bold">{{constants.PRICING_TXT}}</span>
                </h6>
                <h6 class="header-sub-heading" *ngIf="amount === 20">
                    {{constants.GET_ALL_ACCESS_TXT_PRICING}} <br><span
                        class="header-sub-heading-bold">{{constants.PRICING_TXT_20}}</span>
                </h6>
                <button (click)='onClickButton()' class="common-button btn-1">
                    {{constants.UPGRADE_TXT_BTN}}
                </button>
            </div>
            <div class="col-12 col-md-8 detail-table ">
                <table class="info-table">
                    <thead class="table-header">
                        <tr>
                            <th></th>
                            <th class="free-header">
                                <div class="theader-1">{{constants.FREE_MEMBER_TXT}}</div>
                                <h3 class="theader-2">{{constants.FREE_TXT}}</h3>
                                <div class="theader-3">{{constants.FOREVER_TXT}}</div>
                            </th>
                            <th class="prime-header">
                                <div class="theader-1">{{constants.ALL_ACCESS_MEMBER_TXT}}</div>
                                <h3 class="theader-2">{{constants.FIVE_MONTH_TXT}}</h3>
                                <div class="theader-3" *ngIf="amount === 50">{{constants.OR_FIFTY_ANUALLY_TXT}}</div>
                                <div class="theader-3" *ngIf="amount === 20">{{constants.OR_FIFTY_ANUALLY_TXT_20}}</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody class="table-body" *ngFor="let item of constants.PRIME_BENEFITS">
                        <tr>
                            <td class="table-border data-green alignleft" id="pc">{{item.title}}</td>
                            <td class="table-border data-green alignleft" id="mob">{{item.titleMob}}</td>
                            <td class="table-border data-green" *ngIf="item.free === 'img'">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-check svg"
                                    viewBox="0 0 16 16">
                                    <path
                                        d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" />
                                </svg>
                            </td>
                            <td class="table-border data-green alignleft" *ngIf="item.free !== 'img'">
                                {{item.free}}</td>
                            <td class="table-border data-orange alignleft" *ngIf="item.paid !== 'img'">
                                {{item.paid}}</td>
                            <td class="table-border data-orange" *ngIf="item.paid === 'img'">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-check svg"
                                    viewBox="0 0 16 16">
                                    <path
                                        d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" />
                                </svg>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr class="table-footer">
                            <td></td>
                            <td></td>
                            <td>
                                <button (click)='onClickButton()'
                                    class="common-button table-button-margin">{{constants.UPGRADE_TXT_BTN}}</button>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
            <div class="table-button-mob-container">
                <button (click)='onClickButton()'
                    class="common-button table-button-mob">{{constants.UPGRADE_TXT_BTN}}</button>
            </div>

        </div>
    </section>
    <section class="section-2">
        <div class="container">
            <div class="row section-2-content">
                <div class="col-md-8 map-preview-img">
                    <h3 class="map-preview-heading map-preview-heading-mob">{{constants.A_NEW_WAY_TXT}}</h3>
                    <img src="{{constants.MAP_PREVIEW}}" alt="">
                </div>
                <div class="col-md-4 map-preview-content">
                    <h3 class="map-preview-heading map-preview-heading-desk">{{constants.A_NEW_WAY_TXT}}</h3>
                    <p class="map-preview-para">{{constants.NOW_YOU_TXT}}</p>
                </div>
            </div>
        </div>
    </section>
    <section class="container section-3">
        <div class="row">
            <div class="col-sm-6 window-archive">
                <h3 class="window-archive-heading">{{constants.THOUSANDS_CLAMIN_TXT}}</h3>
                <img class="window-archive-img window-archive-img-mob" src="{{constants.POPUP_BEFORE_IMG}}" alt="">
                <p class="window-archive-para">{{constants.ACCESS_OUR_TXT}}</p>
                <button (click)='onClickButton()' class="common-button">{{constants.UPGRADE_5_TXT}}</button>
            </div>
            <div class="col-sm-6 window-archive-img-desk">
                <img class="window-archive-img" src="{{constants.POPUP_BEFORE_IMG}}" alt="">
            </div>
        </div>
    </section>
    <section class="section-4">
        <div class="container section-content">
            <h3 class="playlist-header">{{constants.WHAT_BRING_TXT}}</h3>
            <h3 class="playlist-header">{{constants.A_SNOW_DAYS_TXT}}</h3>
            <h3 class="playlist-header">{{constants.OR_JUST_TXT}}</h3>
            <img class="playlist-img" src="{{constants.PLAY_LIST_MODULE}}" alt="">
            <img class="playlist-img-mob" src="{{constants.PLAYLIST_MODULE}}" alt="">
            <p class="playlist-para">{{constants.GET_JUST}}</p>

        </div>
    </section>
    <section class="section-5">
        <div class="container section-5-container">
            <h3 class="more-header">{{constants.PLUST_A_TXT}}</h3>
            <div class="more-card-group">
                <div class="more-card">
                    <img src="{{constants.PRIME_IMG}}" alt="prime">
                    <p>{{constants.UNLIMITED_BKMRK_TXT}}</p>
                </div>
                <div class="more-card">
                    <img src="{{constants.ARROEPRIME_IMG}}" alt="back">
                    <p>{{constants.ACCESS_TO_TXT}}<br>{{constants.A_BACK_TXT}}</p>
                </div>
                <div class="more-card">
                    <img src="{{constants.MORE_IMG}}" alt="more">
                    <p>{{constants.MORE_TXT}}<br>{{constants.COMING_TXT}}</p>
                </div>
            </div>
            <button (click)='onClickButton()' class="common-button">{{constants.UPGRADE_5_TXT}}</button>
        </div>
    </section>
</div>